import { createContext, useContext, useState } from "react";

const mainContext = createContext();
export const useMainContext = () => {
  return useContext(mainContext);
};
export const ContextProvider = ({children}) => {
  const [data, setData] = useState({employees:217,avgSalary:10000});

  return (
    <mainContext.Provider value={{ setData, data }}>{children}</mainContext.Provider>
  );
};
